import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface NavigationBlockDialogProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  uploadProgress: number;
  fileName?: string;
  fileSize?: number;
  templateName?: string;
}

export const NavigationBlockDialog = ({
  isOpen,
  onCancel,
  onConfirm,
  uploadProgress,
  fileName,
  fileSize,
  templateName,
}: NavigationBlockDialogProps) => {
  return (
    <AlertDialog open={isOpen}>
      <AlertDialogContent className="max-w-md w-full">
        <AlertDialogHeader>
          <AlertDialogTitle>Прервать загрузку файла?</AlertDialogTitle>
          <AlertDialogDescription>
            {fileName && (
              <div className="mb-3 p-3 bg-muted rounded-lg max-w-full overflow-hidden">
                <div className="flex items-center gap-2 min-w-0">
                  <div className="w-6 h-6 bg-brand-100 rounded flex items-center justify-center flex-shrink-0">
                    <span className="text-brand-600 text-xs font-medium">
                      {fileName.split(".").pop()?.toUpperCase()}
                    </span>
                  </div>
                  <div className="min-w-0 flex-1 overflow-hidden">
                    <p
                      className="font-medium text-foreground text-sm break-all"
                      title={fileName}
                      style={{
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical" as const,
                        overflow: "hidden",
                        wordBreak: "break-word",
                      }}
                    >
                      {fileName}
                    </p>
                    {fileSize && <p className="text-xs text-muted-foreground">{(fileSize / (1024 * 1024)).toFixed(1)} МБ</p>}
                  </div>
                </div>
                {templateName && (
                  <div className="mt-2 pt-2 border-t border-border">
                    <p className="text-xs text-muted-foreground truncate">
                      Шаблон: <span className="font-medium">{templateName}</span>
                    </p>
                  </div>
                )}
              </div>
            )}
            Сейчас идет загрузка файла ({Math.round(uploadProgress)}% завершено). Если вы покинете эту страницу,
            загрузка будет прервана.
          </AlertDialogDescription>
          <div className="mt-3 font-medium text-sm text-foreground">Что вы хотите сделать?</div>
        </AlertDialogHeader>
        <AlertDialogFooter className="sm:justify-end">
          <AlertDialogCancel onClick={onCancel} className="w-auto">
            Остаться на странице
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-red-600 hover:bg-red-700 w-auto">
            Прервать загрузку и перейти
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
